<template>
  <div class="container mt-5">
    <b-row>
      <b-col>
        <b-card
          title="Bienvenido a Medinet!!!"
          img-alt="Imagen de bienvenida"
          img-top
        >
          <b-card-text>
            Un software para administración hospitalaria y odontología.
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardText, BRow, BCol } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BRow, BCol,
  },
}
</script>

<style>
</style>
